import { useMutation } from '@tanstack/react-query';

import {
  processBulkMultipleSubscriptionsUpdate,
  type BulkSettingsStoreRef,
} from '@/app/stores/utils/bulk-update-settings';
import { trpc } from '@/lib/api/trpc';
import { useTRPCClient } from '@/lib/api/trpc-provider';

export const useBulkUpdateStoreSettings = () => {
  const utils = trpc.useUtils();
  const client = useTRPCClient();
  return useMutation({
    mutationFn: async (input: {
      stores: BulkSettingsStoreRef[];
      multipleSubscriptionsPerCustomerEnabled: boolean;
    }) =>
      processBulkMultipleSubscriptionsUpdate(
        input.stores,
        input.multipleSubscriptionsPerCustomerEnabled,
        {
          fetchStore: (storeId) => utils.stores.getById.fetch({ storeId }),
          updateStore: (payload) => client.stores.update.mutate(payload),
        },
      ),
    onSuccess: () => {
      utils.stores.getById.invalidate();
      utils.stores.list.invalidate();
      utils.stores.search.invalidate();
    },
  });
};
